import Head from '@component/Head';
import ThemeProvider from '@component/ThemeProvider';
import Layout from '@layouts/Layout';
import { TIMEZONE } from '@lib/constants';
import { getDefaultMessages } from '@lib/l10n';
import { AppContext, AppContextProvider, useAppRef } from '@lib/store';
import { NextIntlClientProvider } from 'next-intl';
import { useRouter } from 'next/router';
import { PropsWithChildren } from 'react';

export type AppRootProps = PropsWithChildren<{ appContext?: AppContext; noLayout?: boolean }>;

const AppRootBody = ({
  children,
  noLayout,
  ...props
}: PropsWithChildren<Omit<AppRootProps, 'appContext'>>) => {
  const layoutRef = useAppRef('layout');
  const router = useRouter();

  return (
    <NextIntlClientProvider
      messages={getDefaultMessages()}
      locale={router.locale}
      timeZone={TIMEZONE}
    >
      <Head />
      {noLayout ? (
        children
      ) : (
        <ThemeProvider>
          <Layout ref={layoutRef} {...props}>
            {children}
          </Layout>
        </ThemeProvider>
      )}
    </NextIntlClientProvider>
  );
};

const AppRoot = ({ children, appContext = {}, noLayout, ...props }: AppRootProps) => {
  return (
    <AppContextProvider value={appContext}>
      <AppRootBody noLayout={noLayout} {...props}>
        {children}
      </AppRootBody>
    </AppContextProvider>
  );
};

export default AppRoot;
